import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper'

const SwiperContainer = forwardRef(({ values, group, slides, initialSlide = null, title = '', onControlChange, reset, isRap = false }, ref) => {
  const [swiper, setSwiper] = useState(null)
  const swiperRef = useRef(null)

  const onSlideChange = () => {
    if (swiper) {
      const { activeIndex, slides } = swiper
      const value = slides[activeIndex].getAttribute('data-js-value')
      onControlChange(group, value)
    }
    if (swiperRef.current) {
      swiperRef.current.classList.remove('isPointerEventsNone')
    }
  }

  useEffect(() => {
    if (swiper) {
      onSlideChange()
    }
    if (swiper && initialSlide !== null) {
      swiper.slideTo(initialSlide)
    }
  }, [swiper, initialSlide])

  useImperativeHandle(ref, () => {
    if (swiper) {
      swiper.params.isRap = isRap
      swiper.params.group = group
    }
    return swiper
  })

  const onBeforeTransitionStart = () => {
    if (swiperRef.current) {
      swiperRef.current.classList.add('isPointerEventsNone')
    }
  }

  const swiperParams = {
    direction: 'vertical',
    slidesPerView: slides,
    spaceBetween: 8,
    centeredSlides: true,
    className: 'calculator-ma__swiper',
    onSwiper: setSwiper,
    onTransitionEnd: onSlideChange,
    onBeforeTransitionStart: onBeforeTransitionStart,
    'data-js-initialslide': initialSlide,
    modules: [FreeMode],
    freeMode: {
      sticky: true,
      minimumVelocity: 0.3
    }
  }

  return (
    <div className='calculator-ma__roller'>
      <p className='calculator-ma__roller-title'>{title}</p>
      <Swiper {...swiperParams} ref={swiperRef}>
        {values.map((value, index) => {
          return group === 'shape' ? <SwiperSlide key={index} data-js-value={value.isRound}>{value.name}</SwiperSlide> : <SwiperSlide key={index} data-js-value={value}>{value}</SwiperSlide>
        })}
      </Swiper>
    </div>
  )
})

export default React.memo(SwiperContainer)
